import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { WorkspaceEmailAliasKind } from "@common/constants/domains/receipts/constants";
import { formatWorkspaceEmailAliasAddress } from "@common/helpers/workspace-email-alias";
import { CopyIcon } from "@icons";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";

export const LocalPartCell = <
    T extends { emailLocalPart: string; kind: WorkspaceEmailAliasKind },
>({
    row,
}: CellContext<ViewTableFeatures, T, string>) => {
    const email = formatWorkspaceEmailAliasAddress({
        emailLocalPart: row.original.emailLocalPart,
        kind: row.original.kind,
    });

    return (
        <CopyOnClick value={email} className="cursor-pointer">
            {email} <CopyIcon className="ml-1" />
        </CopyOnClick>
    );
};
